import { createCustomEvent } from "../../../../javascript/shared/helpers";

export default class extends Controller {
  static targets = ["form"];

  connect() {
    this.replaceContentWithResponse = this.replaceContentWithResponse.bind(this);
    this.replaceFormOnSuccess       = this.replaceFormOnSuccess.bind(this);
    this.replaceFormOnError         = this.replaceFormOnError.bind(this);
    App.Helpers.addHandlers(this.element);
    if (this.hasFormTarget) {
      App.Helpers.addAjaxHandlers(this.formTarget, this.replaceFormOnSuccess, this.replaceFormOnError);
    }
  }

  closeForm(event) {
    event && event.preventDefault();
    const url = this.recordURL;
    if (url) {
      App.Helpers.ajaxRequest({ url, successHandler: this.replaceContentWithResponse });
    } else {
      this.element.remove();
      this.emitCloseEvent();
    }
  }

  replaceContentWithResponse(html) {
    App.Helpers.replaceElement(this.element, html);
    this.emitCloseEvent();
  }

  replaceFormOnSuccess(event, { html }) {
    this.emitCloseEvent();
    this.emitSuccessEvent();
    this.replaceContentWithResponse(html);
  }

  replaceFormOnError(event, { responseText }) {
    this.replaceContentWithResponse(responseText);
  }

  emitCloseEvent() {
    document.dispatchEvent(createCustomEvent("card-list:inline-activity-form-close", this.element, { listID: this.listID }));
  }

  emitSuccessEvent() {
    document.dispatchEvent(createCustomEvent("card-list:activities-update", this.element, { targetListID: this.listID }));
  }

  //
  // GETTERS AND SETTERS
  //

  get recordURL() {
    return this.data.get("record-url");
  }

  get listID() {
    return this.data.get("list-id");
  }
};



// WEBPACK FOOTER //
// ./app/components/card_lists/assets/javascript/card-lists-inline-activity-form-controller.js